import { Directive } from '@angular/core';

@Directive({
  selector: '[auiInlineAlertTitle]',
  exportAs: 'auiInlineAlertTitle',
})
export class InlineAlertTitleDirective {}
